module.exports = require("./ks-Arab.d.ts");